var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-wrapper"},[_c('h2',{attrs:{"data-aos":"fade-in"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h3',{attrs:{"data-aos":"fade-in"}},[_vm._v(_vm._s(_vm.subtitle))]),_vm._v(" "),_vm._t("subtitle")],2)}
var staticRenderFns = []

export { render, staticRenderFns }